import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/SelectDependencies/SelectDependencies.styled.ts",
    _templateObject2,
    _templateObject3,
    _templateObject4,
    _templateObject5,
    _templateObject6,
    _templateObject7;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { IconButton } from '@gmini/ui-kit';
import styled from 'styled-components';
import { DialogContent } from '@gmini/ui-kit/lib/DialogContent';
import { Paper } from '@gmini/ui-kit/lib/Paper';
export var CloseButton = styled(IconButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  && {\n    margin-left: auto;\n\n    & svg path {\n      fill: #353b60;\n    }\n  }\n"])));
export var Title = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 21px;\n  letter-spacing: 0.1px;\n  color: #000335;\n"])));
export var Header = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 18px 24px 20px 24px;\n"])));
export var Separator = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  height: 36px;\n  width: 1px;\n  background: #353b60;\n  opacity: 0.2;\n  margin: 0 24px;\n"])));
export var TabsWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 0 34px;\n"])));
export var Content = styled(DialogContent)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  padding: 0px;\n  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.25);\n"])));
export var DialogBody = styled(Paper)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  height: 100%;\n"])));